import React, {Component} from 'react'
import PropTypes from "prop-types";


class TreatmentVariety extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
   /*     if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }*/
    }

    componentDidMount() {
    }

    editTreatmentPlan = (func,value,index) => {
        this.props.editTreatmentPlan(func,value,index)
        this.props.changeView(5)
    }

    render() {
        let {entry} = this.state
        let currentEntry= this.props.current

        let variety=currentEntry.TreatmentVariety
        let {t}=this.props

        return (
            <div style={{display:this.props.view===4?'block':'none'}}>
                <div className={"treatment-plan-boxes-title"}> {t('patient_boarding.Variety')}</div>

                <div className={"select-method-options"}>
                    <div className={variety ==="Indica" || variety ===t('patient_boarding.Select_All')? "select-method-option-selected" :"select-method-option" }
                         onClick={(event) => this.editTreatmentPlan("TreatmentVariety", "Indica",this.props.index)}>
                        {t('patient_boarding.Indica')}</div>
                <div className={variety ==="Sativa"|| variety ===t('patient_boarding.Select_All') ? "select-method-option-selected" :"select-method-option" }
                         onClick={(event) => this.editTreatmentPlan("TreatmentVariety", "Sativa",this.props.index)}>
                    {t('patient_boarding.Sativa')}</div>
                <div className={variety ==="Blend" || variety ===t('patient_boarding.Select_All') ? "select-method-option-selected" :"select-method-option" }
                         onClick={(event) => this.editTreatmentPlan("TreatmentVariety", "Blend",this.props.index)}>
                    {t('patient_boarding.Blend')}</div>
                <div className={variety ==="Select All" ? "select-method-option-selected" :"select-method-option" }
                         onClick={(event) => this.editTreatmentPlan("TreatmentVariety", "Select All",this.props.index)}>
                    {t('patient_boarding.Select_All')}</div>
                    <div className={"select-method-option-empty"}/>
                    <div className={"select-method-option-empty"}/>
            </div>

            </div>

        )
    }
}

TreatmentVariety.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default TreatmentVariety;
